module.exports = "/img/screen.png?8fd41ba02a80f30798d7f453fa5eebb2";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/identity/screen.png
// module id = asAu
// module chunks = 70